import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dn-dialog-container',
  templateUrl: './dn-dialog-container.component.html',
  styleUrl: './dn-dialog-container.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DnDialogContainerComponent {
  @Input() title: string;
  @Input() titleTop = '0';
  @Input() titleLeft = '0';
  @Input() showCloseButton = true;

  dialogRef: MatDialogRef<DnDialogContainerComponent>;

  constructor(private readonly injector: Injector) {
    this.dialogRef = this.injector.get(MatDialogRef, null);
  }

  close(data: any = null): void {
    this.dialogRef.close(data);
  }
}
